import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import TimerComponent from '../components/TimerComponent';

export default function MultipleChoiceQuestionPage(props) {
    var {importedMCQList, MCQListMirror, userForumStat, keys} = props;

   

    const [encouragementMessages, setEncouragementMessages] = useState(userForumStat ? userForumStat.encouragementMessages : {})
    const [answers, setAnswers] = useState({})
    const [metadata, setMetadata] = useState("")
    const [correctAnswer, setCorrectAnswer] = useState({})
    const [selected, setSelected] = useState({})
    const [name, setName] = useState("")
    const [googleDriveEmbedding, setGoogleDriveEmbedding] = useState(false)
    const [gameover, setGameover] = useState(false);
    const [prevIndex, setPrevIndex] = useState();
    const [prevMetadata, setPrevMetadata] = useState();
    const [questionCount, setQuestionCount] = useState(0);
    const [metadatas, setMetadatas] = useState(userForumStat ? userForumStat.mcqFields : {}) //must have: Id, Image (Image link)
    const [fixedMetadatas, setFixedMetadatas] = useState(userForumStat ? userForumStat.mcqFields : {})
    const [notificationMessage, setNotificationMessage] = useState("");
    const [mcqAnswerName, setMcqAnswerName] = useState(userForumStat ? userForumStat.mcqAnswerName : "Title");
    const [mcqSubject, setMcqSubject] = useState(userForumStat ? userForumStat.mcqSubject : "");
    const [mistake, setMistake] = useState([]);
    const [correctCount, setCorrectCount] = useState(0)
    const [MCQList, setMCQList] = useState(importedMCQList)

    function fisherYatesShuffle(array) {
        array = array.filter(arr=>arr!==undefined)
        let randomIndex;
        let fixedPositionArray = array.filter(i=>i.position)
        let remainder = array.filter(i=>!i.position)
        let currentIndex = remainder.length;

        console.log("remainder.length", remainder.length)
        console.log("array.length", array.length)

        console.log("fixedPositionArray", fixedPositionArray)
        console.log("remainder", remainder)

        // While there remain elements to shuffle.
        while (currentIndex !== 0) {

            // Pick a remaining element.
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;

            // And swap it with the current element.
            [remainder[currentIndex], remainder[randomIndex]] = [
                remainder[randomIndex], remainder[currentIndex]
            ];
        }
        console.log("shuffled remainder", remainder)
        
        fixedPositionArray.sort((a, b) => a.position - b.position);

        console.log("sorted fixedPositionArray", fixedPositionArray)


        fixedPositionArray.map(i=>remainder.splice(i.position-1, 0, i))

        console.log("shuffled + added fixed position boxes", remainder)

       

        return remainder;
    }
    // Refactored function to find the next valid question type
    const findNextQuestionTopic = (passedMetadata) => {
        // 1. Filter out the current (failing) metadata from the pool
        // Use a new array variable here to avoid modifying state immediately
        const remainingMetadatas = metadatas.filter(m => m !== passedMetadata);
        console.log(`End of question topic: ${passedMetadata}. Searching ${remainingMetadatas.length} new types.`);
        let nextValidMetadata = null;
        // 2. Loop synchronously through the remaining candidates to find the first one that works
        for (const candidateMetadata of remainingMetadatas) {
            // 3. Re-run the filter logic using the candidate metadata
            const tempFilteredList = MCQList.filter(
                e => e["Image"] !== "" && e[candidateMetadata]
            );
            // 4. Check if the candidate yields a non-empty list
            if (tempFilteredList.length > 0) {
                nextValidMetadata = candidateMetadata;
                break; // FOUND IT: Exit the loop immediately
            }
        }
        // 5. After the loop, update the state ONCE
        if (nextValidMetadata) {
            setNotificationMessage("Out of questions for topic: "+passedMetadata)
            setTimeout(()=>{
                setNotificationMessage("")
            }, 2000)
            setMetadata(nextValidMetadata); // Set the valid new metadata
            setMetadatas(remainingMetadatas);     // Update the pool of available metadatas
            regenerateQuestion(nextValidMetadata)
            // React will now re-render, and your filter (MCQListWithImages) 
            // will run in the main component body using the new 'passedMetadata'.
        } else {
            console.log("0 topics left");
        }
    };
    const generateQuestion = () => {
        if(fixedMetadatas.length*MCQListMirror.length > questionCount){
            console.log("MCQListMirror", MCQListMirror)
            // fisherYatesShuffle(MCQList)
            setSelected({})
            const randomNumber = Math.random();
            const scaledNumberMetadata = randomNumber * metadatas.length;
            const randomIndexMetadata = Math.floor(scaledNumberMetadata);
            var passedMetadata = metadatas[randomIndexMetadata]
            setMetadata(passedMetadata)
            console.log("Question about ", passedMetadata)
            generateAnswers(passedMetadata)
        }else{
            setGameover(true)
        }
        
    }

    const regenerateQuestion = (passedMetadata) => {
        // fisherYatesShuffle(MCQList)
        setSelected({})
        // setMetadata(passedMetadata)
        console.log("Question about ", passedMetadata)
        generateAnswers(passedMetadata)
    }

    const generateAnswers = async(passedMetadata) => {
        var MCQListWithImages = []
        MCQListWithImages = MCQList.filter(e=>(e.Image&&e[passedMetadata]));
        console.log("MCQListWithImages", MCQListWithImages)
        // if(prevIndex){
        //     //remove the metadata of the correct artwork so that it won't be picked to avoid having the same question on the same artwork next time
        //     console.log("remove ", prevMetadata, ":", MCQList[prevIndex][prevMetadata], " from ", MCQList[prevIndex])
        //     // MCQList[prevIndex][prevMetadata]="";
        //     delete MCQList[prevIndex][prevMetadata];
        //     console.log("remaining properties of that object", MCQList[prevIndex])
        //     console.log("remaining objects and properties ", MCQList)
        // }
        if(MCQListWithImages.length===0 && metadatas.length>0){
            console.log("MCQListWithImages.length===0 && metadatas.length>0");
            console.log("End of question topic: ", passedMetadata);
            findNextQuestionTopic(passedMetadata);
        }else if((MCQListWithImages.length===0 && metadatas.length===0) || (questionCount === fixedMetadatas.length*MCQListMirror.length)){
            console.log("MCQListWithImages.length===0 && metadatas.length===0")
            console.log("End of the test. There is 0 questions left to be done.");
            setGameover(true);
            return "End of the test. There is 0 questions left to be done."
        }else if(MCQListWithImages.length>0){
            console.log("MCQListWithImages.length>0")
            console.log("Question about ", passedMetadata)
            console.log("Question about ", metadata)
            const randomNumber = Math.random();
            const scaledNumber = randomNumber * MCQListWithImages.length;
            const randomIndex = Math.floor(scaledNumber);
            const correctAnswer = MCQListWithImages[randomIndex];
            const correctAnswerId = correctAnswer.Id
            setCorrectAnswer(correctAnswer)
            setPrevIndex(randomIndex);
            setPrevMetadata(passedMetadata)
            console.log("correctAnswer", correctAnswer)
        

            const otherMCQList = fisherYatesShuffle(MCQListMirror.filter((a)=>a[passedMetadata]!==correctAnswer[passedMetadata]))

            var incorrectAnswers = otherMCQList.filter(e => metadatas.every(m => e[m] !== correctAnswer[m])).reduce((acc, currentObject) => {
                // 1. Check if we already have the required number of results
                if (acc.results.length === 3) {
                    return acc; // Stop processing the array
                }
                const value = currentObject[passedMetadata];
                // 2. Check if the field's value is already in the Set
                if (!acc.seenValues.has(value)) {
                    // If unique, add the object to the results and the value to the Set
                    acc.results.push(currentObject);
                    acc.seenValues.add(value);
                }
                return acc; // Return the accumulator for the next iteration
            }, { results: [], seenValues: new Set() }).results;
            console.log("incorrectAnswers", incorrectAnswers)


            const answers = [correctAnswer, ...incorrectAnswers]
            console.log("answers", answers)
            const shuffledAnswers = fisherYatesShuffle(answers)
            if(shuffledAnswers[0]) {shuffledAnswers[0].choice = 'A'}
            if(shuffledAnswers[1]) {shuffledAnswers[1].choice = 'B'}
            if(shuffledAnswers[2]) {shuffledAnswers[2].choice = 'C'}
            if(shuffledAnswers[3]) {shuffledAnswers[3].choice = 'D'}
            console.log("shuffledAnswers", shuffledAnswers)
            setAnswers(shuffledAnswers)
            setQuestionCount(prevQuestionCount => prevQuestionCount+1)
            setTimeout(()=>{
                //remove the metadata of the correct artwork so that it won't be picked to avoid having the same question on the same artwork next time
                // console.log("remove ", passedMetadata, ":", MCQList[randomIndex][passedMetadata], " from ", MCQList[randomIndex])
                // MCQList[prevIndex][prevMetadata]="";
                // delete MCQList[randomIndex][passedMetadata];
                const newMCQList = MCQList.map((item, index) => {
        
                    // 2. Identify the object that needs modification
                    if (item.Id === correctAnswerId) {
                        
                        // 3. Create a shallow copy of the object using spread syntax
                        // This is the CRITICAL step to ensure immutability
                        const newItem = { ...item };
                        console.log("remove ", passedMetadata, ":", item[passedMetadata], " from ", item)
                        // 4. Delete the property from the COPY
                        delete newItem[passedMetadata];
                        
                        // 5. Return the new, modified object
                        return newItem;
                    }
                    
                    // 6. Return all other objects unchanged
                    return item;
                });

                // 7. Update the state with the NEW array reference
                setMCQList(newMCQList);
                console.log("remaining properties of that object", newMCQList.filter(e=>e.Id===correctAnswerId))
                console.log("remaining objects and properties ", newMCQList)
            }, 100)
        }
        
    }

    const convertDriveUrlToDirectLink = (sharingUrl, mode) => {
        if(sharingUrl){
            // Regular expression to find the File ID (the unique string)
            const fileIdMatch = sharingUrl.match(/\/d\/([^/]+)/);
            if (fileIdMatch && fileIdMatch[1]) {
                const fileId = fileIdMatch[1];
                if(mode==="embed"){
                    return `https://drive.google.com/file/d/${fileId}/preview`; 
                }
                // Construct the direct link using the file ID
                // return `https://drive.google.com/uc?export=view&id=${fileId}`;
                // return `https://drive.usercontent.google.com/download?id=${fileId}&export=view`
                return `https://drive.google.com/thumbnail?id=${fileId}&sz=w1000`
                // return `https://lh3.google.com/u/0/d/${fileId}`
            } else {
                console.error("Invalid Google Drive sharing URL format.");
                return null; // Return null if the File ID couldn't be extracted
            }
        }
    }

    const choose = (answer) => {
        if(answer.Id===correctAnswer.Id && encouragementMessages && encouragementMessages.true.length){
            setNotificationMessage(encouragementMessages.true[Math.floor(Math.random() * (encouragementMessages.true.length || 0))])
            setCorrectCount(correctCount+1)
            setTimeout(()=>{
                setNotificationMessage("")
            }, 5000)
        }else if(answer!==null&&answer.Id!==correctAnswer.Id && encouragementMessages && encouragementMessages.true.length){
            setNotificationMessage(encouragementMessages.false[Math.floor(Math.random() * (encouragementMessages.false.length || 0))])
            setMistake(prevMistakes=> [...prevMistakes, {metadata: metadata, ...answers}])
            setTimeout(()=>{
                setNotificationMessage("")
            }, 5000)
        }
        setSelected(answer);
        console.log("setSelected", answer)   
        console.log("selected", selected)
        handlePostGoogleSheet(answer)
    }

    const setTestTaker = (value) => {
        setName(value)
        localStorage.setItem("testTaker", value)
    }
    const getLocalTimestampFormatted = () => {
        const now = new Date();

        // --- Date Components ---
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        const day = String(now.getDate()).padStart(2, '0');

        // --- Time Components ---
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');

        // --- Final Construction ---
        return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
    }

    const handlePostGoogleSheet = async(answer) => {
        console.log(answer)
        const valuesJSON = [name, metadata, correctAnswer['Image'], correctAnswer.choice, correctAnswer[metadata], answer.choice, answer[metadata], getLocalTimestampFormatted(), correctAnswer.Id === answer.Id ? 1 : 0]
        console.log("Google Sheet Values", valuesJSON)
        await fetch(process.env.REACT_APP_GOOGLE_SHEET_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json", "sheetCodename": "mcqArtworks" },
        body: JSON.stringify({
            values: valuesJSON
        })
        });

        const res = await fetch(process.env.REACT_APP_GOOGLE_SHEET_URL)
        const data = await res.json();
        console.log(data);
    }

    const handleImgError = () => {
        //back up plan.
        setGoogleDriveEmbedding(true);
    }

    const openOrSwitchTab = () => {
        window.open(process.env.REACT_APP_MCQ_SHEET, "MCQ Results - Google Sheets");
    }

    useEffect(()=>{
        if(!MCQList){
            setMCQList(importedMCQList)
        }
        console.log("userForumStat", userForumStat)
        if(localStorage.getItem("testTaker")){
            setName(localStorage.getItem("testTaker"))
            console.log("encouragementMessages", encouragementMessages)
        }
        console.log("metadatas", metadatas)
        console.log("MCQList", MCQList)
    }, [importedMCQList, MCQList, userForumStat, encouragementMessages, metadata, answers, selected, googleDriveEmbedding, prevIndex])

    return (
        <div>
            <div className='row center'>
                <div className={`dropdownNotification ${notificationMessage!=="" ? "" : "hidden"}`}>
                    <div className='row center'>{notificationMessage && <i className='fa fa-info'></i>}{notificationMessage}</div></div>
                </div>
            {MCQList && <div className='row center'>
                <input className='mcqTextbox attachment' type='text' onChange={(e)=>setTestTaker(e.target.value)} defaultValue={name ? name : ""} placeholder='Enter your name here'></input>
                <TimerComponent></TimerComponent>
                <button className='attachment' onClick={()=>generateQuestion()}><i className='fa fa-gear'></i>Generate A Question</button>
                <div className='row attachment'>
                    <div>{correctCount}/{questionCount}✔️</div>
                    <div>{mistake.length}/{questionCount}❌</div>
                </div>
            </div>}
            <div className='row center'>From {MCQList && MCQList.filter(e=>e["Image"]!=="").length} artworks</div>
            {gameover && <div className='row center attachment' style={{background: "green", color: "#fff"}}>This is the end of the test.</div>}
            {MCQList && answers && answers.length>0 && <div className='row center'>
                <div className='questionBoard'>
                    <div className='row center'><h3 className='mcqTitle'>Question {questionCount} out of {fixedMetadatas && fixedMetadatas.length*MCQListMirror.length}: {metadata}?</h3></div>
                    <div className='row center'>
                        <div className='row center mcqTitle'>Can't see the image?</div>  
                        <div className='mcqTitle'><Link to={correctAnswer["Image"]} target="_blank"><i className='fa fa-photo'></i>Click here</Link></div>
                    </div>
                    <div className='row center'>
                        
                        {!googleDriveEmbedding ? (correctAnswer ? <Link to={correctAnswer["Image"]} target="_blank">
                            <img className='mcqImage' src={convertDriveUrlToDirectLink(correctAnswer["Image"])} onError={handleImgError}></img>
                        </Link> : <i className='fa fa-spinner'></i>) : ""}
                        {googleDriveEmbedding && <iframe 
                        src={convertDriveUrlToDirectLink(correctAnswer["Image"], "embed")} 
                        width="640" 
                        height="480" 
                        allow="autoplay" 
                        title="Google Drive Document Embed"
                        >
                        </iframe>}
                        
                    </div>
                </div>
                
                <div className='center answerSheet'>
                    <div className='col left'>
                        {
                            selected?.choice && 
                            <div className='row left'>
                                <Link alt="Factcheck" className='attachment googleButton' to={`https://google.com/search?q=${correctAnswer[mcqAnswerName]}+${metadata!==mcqAnswerName ? metadata : ""}`}>
                                🤓🔍
                                </Link>
                                <div className='row' style={{color: "#000", marginRight: "10px"}}>
                                    <i className='fa fa-arrow-left'></i>FACT CHECK
                                </div>
                                <button alt="Result sheet" className='attachment googleSheetButton'onClick={(()=>openOrSwitchTab())}>
                                📋📝
                                </button>
                                <div className='row' style={{color: "#000"}}>
                                    <i className='fa fa-arrow-left'></i>VIEW RESULTS
                                </div>
                            </div>
                        }
                        <div className='row center full' style={{color: "#000"}}>{selected?.choice ? (
                            selected.Id === correctAnswer.Id
                                ? `${selected.choice} is correct.` 
                                : `${selected.choice} is incorrect. ${correctAnswer.choice} is the correct answer.`
                        ) : (
                            'Please select an answer.' 
                        )}</div>
                        <div>{userForumStat && userForumStat.encouragementMessages.true.length}</div>
                        <b className='row center full' style={{color: "#000"}}>
                            {selected?.choice 
                                ? (selected.Id === correctAnswer.Id
                                    ? encouragementMessages && encouragementMessages.true[
                                        Math.floor(Math.random() * (encouragementMessages.true.length || 0))
                                    ]
                                    : encouragementMessages && encouragementMessages.false[
                                        Math.floor(Math.random() * (encouragementMessages.false.length || 0))
                                    ]
                                )
                                : ''
                            }
                        </b>
                        {answers.map((answer)=>
                            <div className='row'>
                                <button disabled={selected.choice ? true : false} className='row full attachment interactiveText' onClick={()=>choose(answer)}>
                                    {`${answer.choice}. ${answer[metadata]}`} {selected!=="" && selected.choice === answer.choice && 
                                        <div className=''>
                                            {selected.Id === answer.Id && (
                                                answer.Id === correctAnswer.Id ? 
                                                <i className='fa fa-check' style={{color: "green"}}></i> : 
                                                <i className='fa fa-x' style={{color: "red"}}></i>
                                            )}                                        
                                        </div>
                                    }
                                </button>
                            </div>)}
                        </div>
                </div>
            </div>}
        </div>
    )
}
